import React, { useState, useMemo } from 'react';
import { 
  BarChart3, 
  Users, 
  ShoppingBag, 
  FileSpreadsheet, 
  ArrowRight, 
  ExternalLink, 
  Bus, 
  HeartPulse, 
  Flame, 
  Landmark, 
  BookOpen, 
  Building2,
  Sprout,
  TrendingUp,
  Search,
  X,
  Layers
} from 'lucide-react';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  // State untuk filter kategori dan pencarian
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // Daftar Seluruh Visualisasi Portal Satu Data Garut
  const dashboards = useMemo(() => [
    {
      id: 1,
      title: "Bahan Pokok & Penting",
      category: "sektoral",
      tag: "Perdagangan & Pasar",
      description: "Pantau pergerakan harga, ketersediaan, dan pasokan bahan pokok (Bapokting) di berbagai pasar Kabupaten Garut secara terpadu.",
      url: "https://visualisasi.garutkab.go.id/bapokting/",
      icon: <ShoppingBag className="w-5 h-5 text-blue-700" />,
      badgeColor: "bg-blue-50 text-blue-700 border-blue-200",
      status: "Live"
    },
    {
      id: 2,
      title: "Kunjungan Wisatawan",
      category: "sektoral",
      tag: "Pariwisata & Budaya",
      description: "Analisis statistik harian dan tren pergerakan wisatawan domestik maupun mancanegara di destinasi wisata unggulan Garut.",
      url: "https://visualisasi.garutkab.go.id/wisatawan/",
      icon: <BarChart3 className="w-5 h-5 text-emerald-700" />,
      badgeColor: "bg-emerald-50 text-emerald-700 border-emerald-200",
      status: "Live"
    },
    {
      id: 3,
      title: "Data Kependudukan",
      category: "sektoral",
      tag: "Kependudukan & Capil",
      description: "Eksplorasi visual sebaran demografi, piramida usia, dan parameter statistik kependudukan warga Kabupaten Garut terkini.",
      url: "https://visualisasi.garutkab.go.id/kependudukan/",
      icon: <Users className="w-5 h-5 text-indigo-700" />,
      badgeColor: "bg-indigo-50 text-indigo-700 border-indigo-200",
      status: "Live"
    },
    {
      id: 4,
      title: "Laporan Permohonan Data",
      category: "sektoral",
      tag: "Keterbukaan Informasi",
      description: "Transparansi rekapitulasi, volume tren bulanan, dan status penanganan permohonan informasi publik dari masyarakat.",
      url: "https://visualisasi.garutkab.go.id/permohonan/",
      icon: <FileSpreadsheet className="w-5 h-5 text-amber-700" />,
      badgeColor: "bg-amber-50 text-amber-700 border-amber-200",
      status: "Live"
    },
    {
      id: 5,
      title: "Trayek Angkutan Umum",
      category: "sektoral",
      tag: "Perhubungan & Transportasi",
      description: "Eksplorasi visual rute perjalanan, titik perhentian, dan analisis jaringan trayek angkutan umum di Kabupaten Garut.",
      url: "https://visualisasi.garutkab.go.id/trayek/",
      icon: <Bus className="w-5 h-5 text-rose-700" />,
      badgeColor: "bg-rose-50 text-rose-700 border-rose-200",
      status: "Live"
    },
    {
      id: 6,
      title: "Data Stunting",
      category: "sektoral",
      tag: "Kesehatan Masyarakat",
      description: "Visualisasi geospasial dan statistik sebaran balita stunting per kecamatan dan puskesmas di Kabupaten Garut.",
      url: "https://visualisasi.garutkab.go.id/stunting/",
      icon: <HeartPulse className="w-5 h-5 text-red-700" />,
      badgeColor: "bg-red-50 text-red-700 border-red-200",
      status: "Live"
    },
    {
      id: 7,
      title: "Insiden Pemadam Kebakaran",
      category: "sektoral",
      tag: "Penyelamatan & Damkar",
      description: "Visualisasi respons dan rekapitulasi data insiden kebakaran, penanganan non-kebakaran (evakuasi darurat), serta armada Disdamkar Garut.",
      url: "https://visualisasi.garutkab.go.id/pemadam/",
      icon: <Flame className="w-5 h-5 text-orange-700" />,
      badgeColor: "bg-orange-50 text-orange-700 border-orange-200",
      status: "Live"
    },
    {
      id: 8,
      title: "Profil Data Pokok & Wilayah (Bab I)",
      category: "profil",
      tag: "Profil Daerah • Bab I",
      description: "Kompilasi ringkas data geografi wilayah, iklim, pemanfaatan lahan, kerawanan bencana alam, demografi kependudukan, serta RTRW.",
      url: "https://visualisasi.garutkab.go.id/bab-I/",
      icon: <Landmark className="w-5 h-5 text-sky-700" />,
      badgeColor: "bg-sky-50 text-sky-700 border-sky-200",
      status: "Live"
    },
    {
      id: 9,
      title: "Profil Potensi Daerah (Bab II)",
      category: "profil",
      tag: "Profil Daerah • Bab II",
      description: "Eksplorasi komprehensif potensi komoditas unggulan pertanian pangan, perkebunan & hortikultura, peternakan domba Garut, perikanan, dan pariwisata.",
      url: "https://visualisasi.garutkab.go.id/bab-II/",
      icon: <Sprout className="w-5 h-5 text-emerald-700" />,
      badgeColor: "bg-emerald-50 text-emerald-700 border-emerald-200",
      status: "Live"
    },
    {
      id: 10,
      title: "Profil Kesejahteraan Rakyat (Bab III)",
      category: "profil",
      tag: "Profil Daerah • Bab III",
      description: "Kompilasi indikator makro ekonomi daerah, PDRB & inflasi, penanggulangan kemiskinan, capaian IPM, ketenagakerjaan, dan kesetaraan gender.",
      url: "https://visualisasi.garutkab.go.id/bab-III/",
      icon: <TrendingUp className="w-5 h-5 text-violet-700" />,
      badgeColor: "bg-violet-50 text-violet-700 border-violet-200",
      status: "Live"
    },
    {
      id: 11,
      title: "Profil Pelayanan Umum & Tata Kelola (Bab IV)",
      category: "profil",
      tag: "Profil Daerah • Bab IV",
      description: "Kinerja urusan pelayanan dasar publik mencakup sarana pendidikan, fasilitas kesehatan, kemantapan infrastruktur jalan, sanitasi, dan APBD.",
      url: "https://visualisasi.garutkab.go.id/bab-IV/",
      icon: <Building2 className="w-5 h-5 text-blue-700" />,
      badgeColor: "bg-blue-50 text-blue-700 border-blue-200",
      status: "Live"
    }
  ], []);

  // Filter gabungan kategori dan pencarian kata kunci
  const filteredDashboards = useMemo(() => {
    return dashboards.filter((item) => {
      const matchCategory = activeCategory === 'all' || item.category === activeCategory;
      const query = searchQuery.trim().toLowerCase();
      if (!query) return matchCategory;

      const matchSearch = 
        item.title.toLowerCase().includes(query) ||
        item.description.toLowerCase().includes(query) ||
        item.tag.toLowerCase().includes(query);

      return matchCategory && matchSearch;
    });
  }, [dashboards, activeCategory, searchQuery]);

  const countAll = dashboards.length;
  const countSektoral = dashboards.filter(d => d.category === 'sektoral').length;
  const countProfil = dashboards.filter(d => d.category === 'profil').length;

  return (
    <div className="min-h-screen bg-[#f8fafc] text-slate-800 flex flex-col font-sans selection:bg-slate-900 selection:text-white">
      
      {/* 1. NAVBAR INSTITUSIONAL BERSIH */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
          
          {/* Identitas Portal */}
          <div className="flex items-center gap-3">
            <img 
              src={process.env.PUBLIC_URL + '/logo.png'} 
              alt="Lambang Kabupaten Garut" 
              className="h-8 sm:h-10 w-auto object-contain"
            />
            <div className="flex flex-col border-l border-slate-300 pl-3">
              <span className="font-bold text-base sm:text-lg tracking-tight text-slate-900 leading-tight">
                Garut Satu Data
              </span>
              <span className="text-[11px] font-medium text-slate-500 uppercase tracking-wider">
                Pusat Visualisasi Data
              </span>
            </div>
          </div>

          {/* Navigasi Utama */}
          <nav className="flex items-center gap-2 sm:gap-3">
            <a 
              href="https://visualisasi.garutkab.go.id/bab-I/" 
              target="_blank"
              rel="noreferrer"
              className="hidden md:inline-flex items-center gap-1.5 text-xs font-semibold text-slate-700 hover:text-blue-700 bg-slate-100 hover:bg-slate-200/80 border border-slate-200 px-3.5 py-2 rounded-lg transition-colors"
            >
              <BookOpen className="w-3.5 h-3.5 text-slate-600" />
              Profil Daerah (Bab I–IV)
            </a>
            <a 
              href="https://satudata.garutkab.go.id" 
              target="_blank" 
              rel="noreferrer" 
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-white bg-blue-700 hover:bg-blue-800 px-3.5 py-2 rounded-lg transition-colors shadow-sm"
            >
              <span>Portal Utama</span>
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </nav>
        </div>
      </header>

      {/* 2. MAIN CONTENT AREA */}
      <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 sm:pt-14 pb-20 w-full">
        
        {/* HERO SECTION - Bersih, Solid, Bebas AI-Slop */}
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-700 border border-slate-200 mb-5">
            <span className="w-2 h-2 rounded-full bg-blue-700"></span>
            Pemerintah Kabupaten Garut • Analitik Data Terpadu
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-slate-900 mb-4 leading-tight">
            Eksplorasi Ragam Visualisasi Data &amp; Wawasan Daerah
          </h1>
          
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed max-w-2xl mx-auto">
            Akses resmi berbagai visualisasi data statistik sektoral dan profil komprehensif Kabupaten Garut secara transparan, akurat, dan terstruktur untuk mendukung pengambilan kebijakan berbasis data.
          </p>
        </div>

        {/* STATS OVERVIEW STRIP - Ringkasan Angka Institusi */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 max-w-4xl mx-auto mb-12 sm:mb-16">
          <div className="bg-white border border-slate-200 rounded-xl p-4 text-center">
            <div className="text-2xl sm:text-3xl font-extrabold text-slate-900">{countAll}</div>
            <div className="text-xs font-medium text-slate-500 mt-1">Dashboard Interaktif</div>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl p-4 text-center">
            <div className="text-2xl sm:text-3xl font-extrabold text-blue-700">4 Bab</div>
            <div className="text-xs font-medium text-slate-500 mt-1">Seri Profil Daerah</div>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl p-4 text-center">
            <div className="text-2xl sm:text-3xl font-extrabold text-slate-900">{countSektoral} Sektor</div>
            <div className="text-xs font-medium text-slate-500 mt-1">Layanan Publik</div>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl p-4 text-center">
            <div className="text-2xl sm:text-3xl font-extrabold text-emerald-700">100%</div>
            <div className="text-xs font-medium text-slate-500 mt-1">Akses Data Terbuka</div>
          </div>
        </div>

        {/* 3. SHOWCASE PUBLIKASI RESMI: SERI PROFIL DAERAH BAB I - IV */}
        <section aria-labelledby="profil-daerah-heading" className="mb-14 bg-slate-900 text-white rounded-2xl p-6 sm:p-8 border border-slate-800">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 mb-7 pb-6 border-b border-slate-800">
            <div>
              <div className="inline-flex items-center gap-2 text-xs font-semibold text-slate-400 mb-2">
                <BookOpen className="w-4 h-4 text-blue-400" />
                <span>Dokumen Tematik Terpadu</span>
              </div>
              <h2 id="profil-daerah-heading" className="text-xl sm:text-2xl font-bold tracking-tight text-white">
                Profil Daerah Kabupaten Garut (Bab I – IV)
              </h2>
              <p className="text-slate-400 text-xs sm:text-sm mt-1.5 max-w-2xl leading-relaxed">
                Serial publikasi visualisasi data kewilayahan, potensi ekonomi daerah, capaian kesejahteraan rakyat, serta evaluasi pelayanan publik dasar Kabupaten Garut.
              </p>
            </div>
            
            <a 
              href="https://visualisasi.garutkab.go.id/bab-I/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-500 text-white font-semibold text-xs sm:text-sm transition-colors shrink-0"
            >
              <span>Mulai dari Bab I</span>
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          {/* 4 Kartu Bab I-IV */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            
            {/* Bab I */}
            <a 
              href="https://visualisasi.garutkab.go.id/bab-I/"
              target="_blank"
              rel="noreferrer"
              className="group bg-slate-800/80 hover:bg-slate-800 border border-slate-700/80 hover:border-slate-600 rounded-xl p-4 transition-colors flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[11px] font-bold text-sky-400 bg-sky-950/80 border border-sky-800 px-2 py-0.5 rounded">
                    BAB I
                  </span>
                  <Landmark className="w-4 h-4 text-sky-400" />
                </div>
                <h3 className="font-semibold text-sm text-white group-hover:text-sky-300 transition-colors">
                  Data Pokok &amp; Wilayah
                </h3>
                <p className="text-xs text-slate-400 mt-1.5 leading-snug">
                  Geografi, iklim, kerawanan bencana alam, demografi penduduk, dan rencana tata ruang (RTRW).
                </p>
              </div>
              <div className="pt-3 mt-4 border-t border-slate-700/60 flex items-center justify-between text-xs text-slate-400 group-hover:text-slate-200">
                <span>Buka Bab I</span>
                <ExternalLink className="w-3.5 h-3.5" />
              </div>
            </a>

            {/* Bab II */}
            <a 
              href="https://visualisasi.garutkab.go.id/bab-II/"
              target="_blank"
              rel="noreferrer"
              className="group bg-slate-800/80 hover:bg-slate-800 border border-slate-700/80 hover:border-slate-600 rounded-xl p-4 transition-colors flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[11px] font-bold text-emerald-400 bg-emerald-950/80 border border-emerald-800 px-2 py-0.5 rounded">
                    BAB II
                  </span>
                  <Sprout className="w-4 h-4 text-emerald-400" />
                </div>
                <h3 className="font-semibold text-sm text-white group-hover:text-emerald-300 transition-colors">
                  Potensi Daerah
                </h3>
                <p className="text-xs text-slate-400 mt-1.5 leading-snug">
                  Komoditas pertanian pangan, perkebunan, domba Garut, perikanan, serta ekosistem pariwisata.
                </p>
              </div>
              <div className="pt-3 mt-4 border-t border-slate-700/60 flex items-center justify-between text-xs text-slate-400 group-hover:text-slate-200">
                <span>Buka Bab II</span>
                <ExternalLink className="w-3.5 h-3.5" />
              </div>
            </a>

            {/* Bab III */}
            <a 
              href="https://visualisasi.garutkab.go.id/bab-III/"
              target="_blank"
              rel="noreferrer"
              className="group bg-slate-800/80 hover:bg-slate-800 border border-slate-700/80 hover:border-slate-600 rounded-xl p-4 transition-colors flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[11px] font-bold text-violet-400 bg-violet-950/80 border border-violet-800 px-2 py-0.5 rounded">
                    BAB III
                  </span>
                  <TrendingUp className="w-4 h-4 text-violet-400" />
                </div>
                <h3 className="font-semibold text-sm text-white group-hover:text-violet-300 transition-colors">
                  Kesejahteraan Rakyat
                </h3>
                <p className="text-xs text-slate-400 mt-1.5 leading-snug">
                  PDRB, inflasi daerah, pengentasan kemiskinan, capaian IPM, ketenagakerjaan, dan kesetaraan gender.
                </p>
              </div>
              <div className="pt-3 mt-4 border-t border-slate-700/60 flex items-center justify-between text-xs text-slate-400 group-hover:text-slate-200">
                <span>Buka Bab III</span>
                <ExternalLink className="w-3.5 h-3.5" />
              </div>
            </a>

            {/* Bab IV */}
            <a 
              href="https://visualisasi.garutkab.go.id/bab-IV/"
              target="_blank"
              rel="noreferrer"
              className="group bg-slate-800/80 hover:bg-slate-800 border border-slate-700/80 hover:border-slate-600 rounded-xl p-4 transition-colors flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[11px] font-bold text-blue-400 bg-blue-950/80 border border-blue-800 px-2 py-0.5 rounded">
                    BAB IV
                  </span>
                  <Building2 className="w-4 h-4 text-blue-400" />
                </div>
                <h3 className="font-semibold text-sm text-white group-hover:text-blue-300 transition-colors">
                  Pelayanan Umum
                </h3>
                <p className="text-xs text-slate-400 mt-1.5 leading-snug">
                  Layanan sarana pendidikan, fasilitas kesehatan, kemantapan jalan, perumahan layak, dan realisasi APBD.
                </p>
              </div>
              <div className="pt-3 mt-4 border-t border-slate-700/60 flex items-center justify-between text-xs text-slate-400 group-hover:text-slate-200">
                <span>Buka Bab IV</span>
                <ExternalLink className="w-3.5 h-3.5" />
              </div>
            </a>

          </div>
        </section>

        {/* 4. KATALOG DASHBOARD: PENCARIAN & FILTER KATEGORI */}
        <section aria-labelledby="katalog-heading">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6 pb-4 border-b border-slate-200">
            <div>
              <h2 id="katalog-heading" className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
                Katalog Dashboard Visualisasi
              </h2>
              <p className="text-xs sm:text-sm text-slate-500 mt-1">
                Gunakan pencarian kata kunci atau saring berdasarkan kategori
              </p>
            </div>

            {/* Search Input Box */}
            <div className="w-full md:w-80 relative">
              <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
              <input 
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Cari nama dashboard atau topik..."
                className="w-full pl-9 pr-8 py-2 bg-white border border-slate-300 rounded-lg text-xs sm:text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition-all"
              />
              {searchQuery && (
                <button 
                  onClick={() => setSearchQuery('')}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                  aria-label="Hapus kata kunci pencarian"
                >
                  <X className="w-4 h-4" />
                </button>
              )}
            </div>
          </div>

          {/* Tab Filter Kategori */}
          <div className="flex flex-wrap items-center gap-2 mb-6">
            <button
              onClick={() => setActiveCategory('all')}
              className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold transition-colors ${
                activeCategory === 'all'
                  ? 'bg-slate-900 text-white'
                  : 'bg-white text-slate-600 hover:text-slate-900 border border-slate-200'
              }`}
            >
              Semua ({countAll})
            </button>
            <button
              onClick={() => setActiveCategory('sektoral')}
              className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold transition-colors ${
                activeCategory === 'sektoral'
                  ? 'bg-slate-900 text-white'
                  : 'bg-white text-slate-600 hover:text-slate-900 border border-slate-200'
              }`}
            >
              Layanan Sektoral ({countSektoral})
            </button>
            <button
              onClick={() => setActiveCategory('profil')}
              className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold transition-colors ${
                activeCategory === 'profil'
                  ? 'bg-slate-900 text-white'
                  : 'bg-white text-slate-600 hover:text-slate-900 border border-slate-200'
              }`}
            >
              Profil Daerah Bab I–IV ({countProfil})
            </button>
            
            {searchQuery && (
              <span className="text-xs text-slate-500 ml-auto py-1">
                Menampilkan {filteredDashboards.length} hasil
              </span>
            )}
          </div>

          {/* Grid Kartu Dashboard */}
          <ErrorBoundary>
            {filteredDashboards.length === 0 ? (
              <div className="bg-white border border-slate-200 rounded-xl p-10 text-center max-w-md mx-auto my-8">
                <Layers className="w-8 h-8 text-slate-400 mx-auto mb-3" />
                <h3 className="text-base font-bold text-slate-900 mb-1">
                  Tidak Ada Hasil Ditemukan
                </h3>
                <p className="text-xs text-slate-500 mb-4">
                  Tidak ditemukan visualisasi dengan kata kunci &quot;{searchQuery}&quot;.
                </p>
                <button
                  onClick={() => {
                    setSearchQuery('');
                    setActiveCategory('all');
                  }}
                  className="px-3.5 py-2 text-xs font-semibold bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors"
                >
                  Reset Filter &amp; Pencarian
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5 sm:gap-6">
                {filteredDashboards.map((dash) => {
                  const isLive = dash.status === 'Live';
                  
                  return (
                    <ErrorBoundary key={dash.id}>
                      <a 
                        href={isLive ? dash.url : undefined}
                        target={isLive ? "_blank" : "_self"}
                        rel="noreferrer"
                        className={`group p-6 bg-white rounded-xl border border-slate-200 hover:border-slate-300 hover:shadow-sm transition-all duration-200 flex flex-col justify-between ${
                          !isLive ? 'opacity-70 cursor-default' : ''
                        }`}
                      >
                        <div>
                          {/* Header Kartu: Ikon & Tag */}
                          <div className="flex items-center justify-between mb-4">
                            <div className={`w-10 h-10 rounded-lg ${dash.badgeColor} border flex items-center justify-center shrink-0`}>
                              {dash.icon}
                            </div>
                            
                            <div className="flex items-center gap-2">
                              {dash.tag && (
                                <span className="text-[11px] font-medium text-slate-600 bg-slate-100 px-2.5 py-0.5 rounded border border-slate-200/80">
                                  {dash.tag}
                                </span>
                              )}
                              
                              {/* Status Badge Bersih (Solid dot tanpa kedap-kedip) */}
                              <span className="inline-flex items-center text-[11px] font-semibold text-slate-700 bg-slate-50 border border-slate-200 px-2 py-0.5 rounded">
                                <span className="w-1.5 h-1.5 rounded-full bg-emerald-600 mr-1.5"></span>
                                Aktif
                              </span>
                            </div>
                          </div>
                          
                          {/* Judul Visualisasi */}
                          <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-2 tracking-tight group-hover:text-blue-700 transition-colors">
                            {dash.title}
                          </h3>
                          
                          {/* Deskripsi Visualisasi */}
                          <p className="text-xs sm:text-sm text-slate-600 leading-relaxed mb-6">
                            {dash.description}
                          </p>
                        </div>

                        {/* Tombol Navigasi Bawah */}
                        <div className="pt-3.5 border-t border-slate-100 flex items-center justify-between text-xs mt-auto">
                          <span className="font-semibold text-blue-700 inline-flex items-center gap-1 group-hover:gap-1.5 transition-all">
                            <span>Buka Dashboard Analisis</span>
                            <ArrowRight className="w-3.5 h-3.5" />
                          </span>
                          <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-blue-700 transition-colors" />
                        </div>
                      </a>
                    </ErrorBoundary>
                  );
                })}
              </div>
            )}
          </ErrorBoundary>
        </section>

      </main>

      {/* 5. FOOTER INSTITUSIONAL RESMI */}
      <footer className="border-t border-slate-200 bg-white mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pb-6 border-b border-slate-200/80">
            <div>
              <div className="font-bold text-sm text-slate-900">
                Pemerintah Kabupaten Garut
              </div>
              <div className="text-xs text-slate-500 mt-0.5">
                Dinas Komunikasi dan Informatika (Diskominfo) Kabupaten Garut
              </div>
            </div>

            <div className="flex flex-wrap gap-4 text-xs font-semibold text-slate-600">
              <a 
                href="https://satudata.garutkab.go.id" 
                target="_blank" 
                rel="noreferrer"
                className="hover:text-blue-700 transition-colors"
              >
                Portal Satu Data
              </a>
              <a 
                href="https://garutkab.go.id" 
                target="_blank" 
                rel="noreferrer"
                className="hover:text-blue-700 transition-colors"
              >
                Website Resmi Garutkab
              </a>
              <a 
                href="https://garutkab.bps.go.id" 
                target="_blank" 
                rel="noreferrer"
                className="hover:text-blue-700 transition-colors"
              >
                BPS Kabupaten Garut
              </a>
            </div>
          </div>

          <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
            <p>© {new Date().getFullYear()} Pemerintah Kabupaten Garut. Hak Cipta Dilindungi.</p>
            <p className="text-slate-400">Pusat Visualisasi Data v2.0</p>
          </div>
        </div>
      </footer>

    </div>
  );
}

export default App;